Wee.fn.make('quantity', {
	init: function() {
		this.changeQuantity();
	},

	changeQuantity: function() {
		$.events.on({
			'ref:changeQuantity': {
				click: function(e, el) {
					var count = parseInt($('ref:currentQuantity').val());

					if (el.hasAttribute('data-down')) {
						if (count === 1) {
							return;
						}
						count--;
					} else {
						count++;
					}

					$('ref:currentQuantity').val(count);
				}
			}
		}, {
			namespace: 'changeQuantity'
		});
	},

	unload: function() {
		$.events.off(false, '.changeQuantity');
	}
}, {
});